import { render, staticRenderFns } from "./goods-tie.vue?vue&type=template&id=d05f8f84&scoped=true&"
import script from "./goods-tie.vue?vue&type=script&lang=js&"
export * from "./goods-tie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05f8f84",
  null
  
)

export default component.exports